import { useI18n } from '#/i18n/hooks/useI18n';
import { SearchFilterAccordionItem } from '#/modules/search/components/Filter/AccordionItem/SearchFilterAccordionItem';
import { SearchFilterToggleButton } from '#/modules/search/components/Filter/ToggleButton/SearchFilterToggleButton';
import { useSearchFacetSelectedValues } from '#/modules/search/hooks/facets/useSearchFacetSelectedValues';
import type { SearchRefinementVariant } from '#/modules/search/types/SearchRefinementVariant';

type Props = {
  variant: SearchRefinementVariant;
};

export function DoneInADayFilter({ variant }: Props) {
  const { i18n } = useI18n();

  const selectedFacetValueRaw = useSearchFacetSelectedValues('canBeDoneInADay');
  const selectedFacetValue = Boolean(selectedFacetValueRaw[0]);

  const FilterVariant =
    variant === 'accordion'
      ? SearchFilterAccordionItem
      : SearchFilterToggleButton;

  return (
    <FilterVariant
      facetType="canBeDoneInADay"
      initialValue={selectedFacetValue}
      icon="hammer"
      label={<>{i18n('Show only Done in a Day')} </>}
    />
  );
}
